import { _ as _sfc_main } from "./VaParallax.vue_vue_type_script_lang-7ca159b7.mjs";
import { openBlock, createElementBlock, normalizeStyle, createElementVNode, renderSlot } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaParallax_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = { class: "va-parallax__image-container" };
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = { class: "va-parallax__item-container" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: "rootElement",
    class: "va-parallax",
    style: normalizeStyle(_ctx.computedWrapperStyles)
  }, [
    createElementVNode("div", _hoisted_1, [
      createElementVNode("img", {
        ref: "img",
        class: "va-parallax__image",
        src: _ctx.$props.src,
        alt: _ctx.$props.alt,
        style: normalizeStyle(_ctx.computedImgStyles)
      }, null, 12, _hoisted_2)
    ]),
    createElementVNode("div", _hoisted_3, [
      renderSlot(_ctx.$slots, "default")
    ])
  ], 4);
}
const _VaParallax = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaParallax as _
};
//# sourceMappingURL=VaParallax-532fa783.mjs.map
